"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
class ComponentDoc extends react_1.PureComponent {
    render() {
        const { name, demoName, propInfos, remarks, children } = this.props;
        return (react_1.default.createElement("div", null,
            react_1.default.createElement("div", { className: "row", style: { paddingBottom: '10px' } },
                react_1.default.createElement("div", { className: "col-md-12" },
                    react_1.default.createElement("h2", null, name),
                    propInfos.length ? react_1.default.createElement(PropsTable, { propInfos: propInfos }) : null,
                    react_1.default.createElement("div", null, remarks))),
            children ? (react_1.default.createElement("div", { className: "row", style: { paddingBottom: '30px' } },
                react_1.default.createElement("div", { className: "col-md-12" },
                    react_1.default.createElement("h3", null, demoName),
                    children))) : null));
    }
}
exports.default = ComponentDoc;
ComponentDoc.propTypes = {
    name: prop_types_1.default.string.isRequired,
    demoName: prop_types_1.default.string,
    propInfos: prop_types_1.default.arrayOf(prop_types_1.default.node),
    remarks: prop_types_1.default.element,
    children: prop_types_1.default.oneOfType([prop_types_1.default.element, prop_types_1.default.arrayOf(prop_types_1.default.element)]),
};
ComponentDoc.defaultProps = {
    propInfos: [],
    demoName: 'Demo',
};
